import React, { useState } from 'react';
import './zoneBox.scss';

// «مرزبندیِ فضا» — قدمِ اول: اسمِ قسمت (مثلاً پذیرایی) و، اختیاری، مساحتش. بعد کاربر مرز را با انگشت روی پلان
// می‌کشد. اگر مساحت داده شود، مرز خودش جابه‌جا می‌شود تا قسمت همان مساحت را داشته باشد.
const toLatin = (s) =>
  String(s || '')
    .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
    .replace(/[٫,]/g, '.')
    .replace(/[^\d.]/g, '');
const toFa = (s) => String(s).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]).replace('.', '٫');

const QUICK = ['پذیرایی', 'آشپزخانه', 'ناهارخوری', 'نشیمن', 'راهرو'];

function ZoneBox({ onStart, onCancel }) {
  const [name, setName] = useState('');
  const [area, setArea] = useState('');
  const submit = (e) => {
    e.preventDefault();
    const a = Number(area);
    onStart(name.trim() || 'بدون‌نام', a > 0.5 ? a : null);
  };
  return (
    <div className="zone-box__backdrop">
      <form className="zone-box" onSubmit={submit}>
        <strong className="zone-box__title">مرزبندیِ فضا</strong>
        <p className="zone-box__lead">اسمِ قسمتی که می‌خواهید جدا شود را بنویسید؛ بعد مرزش را با انگشت روی پلان بکشید.</p>
        <input type="text" autoFocus placeholder="مثلاً پذیرایی" value={name} onChange={(e) => setName(e.target.value)} />
        <div className="zone-box__chips">
          {QUICK.map((q) => (
            <button key={q} type="button" className={name === q ? 'is-on' : ''} onClick={() => setName(q)}>
              {q}
            </button>
          ))}
        </div>
        <label className="zone-box__area">
          <input
            type="text"
            inputMode="decimal"
            placeholder="مساحت"
            value={toFa(area)}
            onChange={(e) => setArea(toLatin(e.target.value).slice(0, 6))}
          />
          <span>متر مربع (اختیاری)</span>
        </label>
        <div className="zone-box__actions">
          <button type="submit" className="is-primary">
            کشیدنِ مرز
          </button>
          <button type="button" onClick={onCancel}>
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
}

export default ZoneBox;
